var openLogin = {

	linkToLogin: $('.link-login'),
	loginTrigger: $('#login .dropdown-button'),
	loginDropdown: $('#login .dropdown-select'),

	openLoginPanel: function() {
		nav.stickyNav.undoSticky();
		openLogin.loginTrigger.addClass('active');

		setTimeout( function() {
			openLogin.loginDropdown.show();
		}, 500);
	},

	eventListeners: function() {
		openLogin.linkToLogin.on('click', function( e ) {
			e.preventDefault();
			openLogin.openLoginPanel();
		});
	},

	init: function() {
		if (windowWidth >= desktop) {
			openLogin.eventListeners();
		}
	}
};